// import React from "react";
// import { AiOutlineCheckCircle } from "react-icons/ai";
// import { RxCrossCircled } from "react-icons/rx";
// import { BiErrorCircle } from "react-icons/bi";

// function Alert({ alertBox, alert, setAlertBox }) {
//   if (!alertBox || !alert) return null;
//   // Determine alert styles and icon based on type
//   const alertStyles = {
//     success: {
//       color: "text-green-600",
//       bg: "bg-green-100",
//       icon: <AiOutlineCheckCircle size={60} className="text-green-600" />,
//     },
//     error: {
//       color: "text-red-600",
//       bg: "bg-red-100",
//       icon: <RxCrossCircled size={60} className="text-red-600" />,
//     },
//     warning: {
//       color: "text-yellow-600",
//       bg: "bg-yellow-100",
//       icon: <BiErrorCircle size={60} className="text-yellow-600" />,
//     },
//   };

//   const alertType = alertStyles[alert.color] || alertStyles.success;

//   return (
//     <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
//       <div
//         className={`max-w-sm w-full ${alertType.bg} shadow-lg rounded-lg p-6 text-center animate-fadeIn`}
//       >
//         <div className="flex justify-center mb-4">{alertType.icon}</div>
//         <h2 className={`text-lg font-semibold ${alertType?.color12} mb-4`}>{alert.message}</h2>
//         <button
//           className="w-full px-4 py-2 bg-[#0068ff] text-white rounded-md hover:bg-customBlue-dark focus:outline-none focus:ring-2 focus:ring-blue-500"
//           onClick={() => setAlertBox(false)}
//         >
//           OK
//         </button>
//       </div>
//     </div>
//   );
// }

// export default Alert;


import React from "react";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { RxCrossCircled } from "react-icons/rx";
import { BiErrorCircle } from "react-icons/bi";

function Alert({ alertBox, alert, setAlertBox }) {
  if (!alertBox || !alert) return null;

  // Dark theme alert styles
  const alertStyles = {
    success: {
      color: "text-green-400",
      bg: "bg-[#161616] border border-green-600",
      icon: <AiOutlineCheckCircle size={60} className="text-green-400" />,
    },
    error: {
      color: "text-red-400",
      bg: "bg-[#161616] border border-red-600",
      icon: <RxCrossCircled size={60} className="text-red-400" />,
    },
    warning: {
      color: "text-yellow-400",
      bg: "bg-[#161616] border border-yellow-600",
      icon: <BiErrorCircle size={60} className="text-yellow-400" />,
    },
  };

  const alertType = alertStyles[alert.color] || alertStyles.success;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-70 z-50">
      <div className={`max-w-sm w-full ${alertType.bg} shadow-lg rounded-lg p-6 text-center animate-fadeIn`}>        
        <div className="flex justify-center mb-4">{alertType.icon}</div>
        <h2 className={`text-lg font-semibold ${alertType.color} mb-4`}>{alert.message}</h2>
        <button
        className="border-2 border-customBlue px-4 py-2 rounded text-white hover:bg-background-primary transition text-[15px] font-bold uppercase"
          // className="w-full px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          onClick={() => setAlertBox(false)}
        >
          OK
        </button>
      </div>
    </div>
  );
}

export default Alert;